// Marketing Pages — layout route (M4).
//
// `_authed.pages.$id` and `_authed.pages.$id.blocks.$blockId` nest under this
// file, so it must render an <Outlet/> or the children never mount. The list
// itself lives in `_authed.pages.index.tsx`.
//
// (Pre-M4 this file WAS the list and had no Outlet, which meant /pages/$id
// rendered the list instead of the composer.)

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/pages')({
  component: () => <Outlet />,
});
